export default __webpack_public_path__ + "static/media/icon_delete_msgbox.8bbe6542.svg";